<template>
  <my-dialog
    class="notice-dlg"
    v-model="noticeVisible"
    :modal="false"
    btnSure=""
    btnCancle=""
    :title="$tex('通知')"
  >
    <i class="iconfont icon-close" @click.stop="noticeVisible = false"></i>
    <div @click.stop="jumpNotice">
      {{ noticeContent }}
    </div>
  </my-dialog>
</template>

<script>
import MyDialog from "../MyDialog";
import { mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/utils/eventBus";
import * as RongYun from "@/utils/rongyun";
import isEmpty from "lodash/isEmpty";
import {
  PushTypes,
  RongYunConnectStatus,
  MessageEventBusTypes
} from "@/constant/rongyun";
import { Dialog } from "vant";

export default {
  name: "Socket",
  components: { MyDialog },
  props: {
    plat: false,
  },
  data() {
    return {
      noticeVisible: false,
      noticePath: "",
      noticeContent: "",
      connectIndex: 0,
      typingMsg: [
        "SyncReadStatusMessage",
        "TypingStatusMessage",
        "SyncReadStatusMessage"
      ]
    };
  },
  computed: {
    ...mapGetters([
      "appDownloadURl",
      "user",
      "chatUser",
      "grabRongyunId",
      "currChatRoomInfo",
      "currHbBattleRoomInfo",
      "userYebInfo",
      "rongYunConnectStatus"
    ])
  },
  watch: {
    user(n, o) {
      if (n && o && n.userCode === o.userCode) {
        return;
      }
      RongYun.disconnect();
      //不能像下方写法.catch 一断掉就重连，断线时会造成无限回圈使浏览器内存泄露
      this.connectRongYun();
      // this.connectRongYun().catch(()=>{console.log("监听部份Socket链接融云失败 开始重连");this.connectRongYun();});
    },
    rongYunConnectStatus(value) {
      //joinstate: 0 -> 融云在断线状况   1 -> 融云在在线状况
      switch (value) {
        case RongYunConnectStatus.ERROR: // 连接失败
          this.SET_CHATROOM_JOIN_STATE(0);
          break;
        case RongYunConnectStatus.CONNECTED: // 链接成功
          this.SET_CHATROOM_JOIN_STATE(1);
          this.ryConnectSuccessHandler();
          break;
        case RongYunConnectStatus.CONNECTING: // 正在连接中
          break;
        case RongYunConnectStatus.DISCONNECTED: // 用户主动断开链接
          this.SET_CHATROOM_JOIN_STATE(0);
          if (!isEmpty(this.user)) {
            this.$store.dispatch("connectRongYun");
          }
          break;
        case RongYunConnectStatus.SUSPEND: // 网络不可用, SDK 内部自动重连
          break;
        case RongYunConnectStatus.NETWORK_UNAVAILABLE: // 网络不可用, SDK 内部会自动重连
          this.SET_CHATROOM_JOIN_STATE(0);
          break;
        case RongYunConnectStatus.SOCKET_ERROR: // Socket 不可用, SDK 内部会自动重连
          this.SET_CHATROOM_JOIN_STATE(0);
          break;
        case RongYunConnectStatus.KICKED_OFFLINE_BY_OTHER_CLIENT: // 被其他端踢掉
          this.SET_CHATROOM_JOIN_STATE(0);
          this.otherDeviceLoginHandler();
          break;
        case RongYunConnectStatus.BLOCKED: // 用户被封禁
          break;
        default:
          this.SET_CHATROOM_JOIN_STATE(1);
          break;
      }
    }
  },
  created() {
    EventBus.addEventListener("messageStore", this.messageStore, this);
    this.connectRongYun();
    //不能像下方写法.catch 一断掉就重连，断线时会造成无限回圈使浏览器内存泄露
    // this.connectRongYun().catch(()=>{console.log("Socket链接融云失败 开始重连");this.connectRongYun();});
  },
  beforeDestroy() {
    EventBus.removeEventListener("messageStore", this.messageStore, this);
    this.closeTimer && clearTimeout(this.closeTimer);
  },
  methods: {
    ...mapActions([
      "getUrlForDownload",
      "registerRongYunAccount",
      "getRyToken",
      "loginOutUser"
    ]),
    ...mapMutations([
      "ADD_GRAB_ROOM_MESSAGE",
      "SET_CHATROOM_JOIN_STATE",
      "SET_USER_INFO",
      "SET_USER_KEY_VAL",
      "ADD_CHATROOM_MSG",
      "ADD_HB_BATTLE_ROOM_MSG",
      "SET_CHATROOM_PRIZE_INFO",
      "SET_CHATROOM_NOTICE_MODIFY",
      "SET_GRAB_RECEIVE_ROOM_MSG",
      "SET_CHATROOM_HEADLINE",
      "SET_CHATROOM_ANNOUNCE_INFO",
      "SET_CHATROOM_All_SPEACKSTATUS",
      "ADD_SINGLE_PRIVATE_MSG",
      "SET_USER_YEB_INFO",
      "IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE",
      "CHANGE_CURR_CHAT_USER_INFO",
      "SET_CHATROOM_INSTANCE_SPEAK_STATUS",
      "SET_GRAB_ROOM_SPEECH_MODE",
      "SET_CHAT_PUSH_MEMBER_MSG"
    ]),
    isFilterTypStsTypeMessage(message) {
      return message.messageType === "RC:TypSts";
    },
    messageStore(event) {
      const message = event.target;
      const messageContent = message.content;
      const extra = messageContent.extra;
      if (this.isFilterTypStsTypeMessage(message)) {
        return;
      }
      if (
        message.conversationType === RongIMLib.ConversationType.CHATROOM &&
        message.targetId === this.currChatRoomInfo.ryChatRoomId
      ) {
        //聊天室等级禁言和发言模式等
        if (extra.type === PushTypes.CHATROOM_BANNED_LEVEL) {
          this.SET_CHATROOM_INSTANCE_SPEAK_STATUS(extra);
          return;
        }

        if (messageContent.content === PushTypes.KEEP_ALIVE) return;

        if (messageContent.content !== PushTypes.CHATROOM_NOTICE) {
          message.state = 1;
          this.ADD_CHATROOM_MSG(message);
          this.$EventBus.$emit(MessageEventBusTypes.kChatRoomMessage, message);
          return;
        }
      } else if (
        message.conversationType === RongIMLib.ConversationType.PRIVATE
      ) {
        this.ADD_SINGLE_PRIVATE_MSG(message);
        this.$EventBus.$emit(MessageEventBusTypes.kChatPrivateMessage, message);
        //提取消息中发送方的信息
        const hisInfo = RongYun.MessageManager.getInstance().getSenderUserByMessage(
          message
        );
        const { name } = this.$route;
        if (name !== "privateRoom") {
          this.IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE({
            hisInfo,
            messageUId: message.messageUId,
            isShowNotice: true
          });
        }
        return;
      } else if (
        message.conversationType === RongIMLib.ConversationType.CHATROOM &&
        message.targetId === this.currHbBattleRoomInfo.rongyunChatId
      ) {
        // 红包大战房间
        this.ADD_HB_BATTLE_ROOM_MSG(message);
        this.$EventBus.$emit(
          MessageEventBusTypes.kChatRedPacketBattleMessage,
          message
        );
        return;
      }
      if (message.targetId === this.grabRongyunId) {
        if (extra.type === PushTypes.ROB_ZHUANG_ROOM_SPEAK_MODE) {
          const { speechMode } = extra;
          this.SET_GRAB_ROOM_SPEECH_MODE(speechMode);
          return;
        }
        this.SET_GRAB_RECEIVE_ROOM_MSG(message);
        this.$EventBus.$emit(
          MessageEventBusTypes.kChatGrabRoomMessage,
          message
        );
        return;
      }
      if (!extra) return;
      const extraType = extra.type;

      switch (extraType) {
        case PushTypes.MEMBER_MSG:
          this.SET_CHAT_PUSH_MEMBER_MSG(message);
          break;
        case PushTypes.LOTTERY: // 开奖结果
        case PushTypes.LOTTERY_PUT_RIGHT: // 开奖结果出错
          this.SET_CHATROOM_NOTICE_MODIFY(
            Object.assign(
              {
                path: "/prizeNotice",
                path2: "/buyLottery",
                path3: "/historyList",
                path4: "/chatRoom"
              },
              extra
            )
          );
          break;
        case PushTypes.SYSTEM_NOTICE: // 最新公告
          this.noticePath = "/information/sys?type=02";
          this.openNotice(extra.title);
          this.SET_CHATROOM_NOTICE_MODIFY({
            path: this.noticePath
          });
          break;
        case PushTypes.SPECIAL_OFFERS: // 优惠活动
          this.noticePath = "/active_detail/" + extra.resourceId;
          this.openNotice(extra.title);
          this.SET_CHATROOM_NOTICE_MODIFY({
            path: "/active"
          });
          break;
        case PushTypes.LOTTERY_ORDER: //  中奖通知
          this.noticePath = "/bettingDetail/" + extra.userBettingRecordId;
          this.openNotice(extra.message);
          this.SET_CHATROOM_NOTICE_MODIFY({
            path: this.noticePath,
            path1: "/bettingList"
          });
          break;
        case PushTypes.USER_BALANCE_CHANGE: //  金额变动
          this.SET_USER_KEY_VAL({ balance: Number(extra.balance) });
          break;
        case PushTypes.CHATROOM_AUTH_CHANGE: // 手动修改用户禁言状态等
          this.CHANGE_CURR_CHAT_USER_INFO(extra);
          break;
        case PushTypes.FIREWORKS_EXPLODE:
          this.SET_CHATROOM_PRIZE_INFO(extra);
          break;
        case PushTypes.CHATROOM_NOTICE:
          {
            const annouceInfo = extra.annouceInfo;
            if (annouceInfo) {
              if (annouceInfo.type === "1") {
                //彩票头条
                this.SET_CHATROOM_HEADLINE(annouceInfo);
              } else if (annouceInfo.type === "2") {
                //弹框
                this.SET_CHATROOM_ANNOUNCE_INFO(annouceInfo);
              }
            }
          }
          break;
        case PushTypes.CHATROOM_ALL_BANNED: //全员禁言, 1为禁言
          this.SET_CHATROOM_All_SPEACKSTATUS(
            extra.data.USER_BANNED_SWITCH !== "1"
          );
          break;
        case PushTypes.GIFT_BAG_ALERT: // 活动礼包
          this.openNotice(
            this.$tex("您有一个礼包待领取，请点击下载app，打开礼包中心领取！"),
            true
          );
          break;
        case PushTypes.YUEBAO_BALANCE_CHANGE: // 余额宝余额变动
          this.userYebInfo.balance = extra.balance;
          this.SET_USER_YEB_INFO(extra);
          break;
      }
    },
    connectRongYun() {
      this.SET_CHATROOM_JOIN_STATE(0);
      // if (!isEmpty(this.user)){
      //   this.$store.dispatch("connectRongYun");
      // }
      this.$store.dispatch("connectRongYun");
    },
    /**
     * 过滤输入中的状态消息
     */
    filterTypingMsg(newVal) {
      let { messageName } = newVal.content;
      if (this.typingMsg.includes(messageName)) {
        return true;
      }
      return false;
    },
    /**
     * 提取当前发送消息方的信息(私聊)
     */
    getSenderUserInfo(msg) {
      // console.log("触发socket getSenderUserInfo");
      let { user = {}, extra = {} } = msg.content;

      if (typeof extra === "string") {
        extra = JSON.parse(extra);
      }
      const senderUser = extra.senderUser || {};
      // console.log("senderUser发送方信息",senderUser);
      return {
        // nickName: user.name, // 2019.12.10
        userCode: senderUser.userCode, // 2019.12.10
        nickName: senderUser.nickName, // 2019.12.10
        user: {
          portrait: user.portrait,
          name: user.name,
          sendUserLevelIcon: user.sendUserLevelIcon,
          id: msg.targetId
        }
      };
    },
    async jumpNotice() {
      if (this.downLoad) {
        await this.getUrlForDownload();
        if (this.appDownloadURl) {
          window.location.href = this.appDownloadURl;
        }
      } else if (this.noticePath) {
        let routeParam = {
          path: this.noticePath
        };
        this.$router.push(routeParam);
        this.noticeVisible = false;
      }
    },
    openNotice(message, downLoad = false) {
      this.noticeContent = message;
      this.noticeVisible = true;
      this.downLoad = downLoad;
      this.closeNotice();
    },
    closeNotice() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.closeTimer = window.setTimeout(() => {
        this.noticeVisible = false;
      }, 5000);
    },
    clearLoginInfo() {
      if (!this.user.userCode) {
        return;
      }
      this.loginOutUser({
        data: {},
        config: { userId: true }
      }).then(response => {
        if (response.data.code !== 0) return;
        this.$router.push("/");
      });
    },
    // 监听融云链接成功后的回调函数
    async ryConnectSuccessHandler() {
      this.$store.dispatch("joinRongYunChatRoom", {
        count: 1
      });
      //只拉取登录用户的消息列表
      const privateList = await RongYun.getConversationList();
      privateList &&
        RongYun.getConversationList()
          .then(conversationList => {
            const privateList = conversationList.filter(
              item => item.type === RongIMLib.ConversationType.PRIVATE
            );
            this.$store.commit("SET_CHAT_ROOM_PRIVATE_MSG_LIST", privateList);
          })
          .catch(e => {
            console.log("getConversationList error", e);
          });
      //连接融云成功的标识
      this.SET_CHATROOM_JOIN_STATE(1);
      this.connectIndex = 0;
    },
    otherDeviceLoginHandler() {
      RongYun.disconnect();
      //其他设备登录
      let clientType = localStorage.getItem("loginClientType"); //设备类型
      clientType = clientType ? clientType : "wap";
      if (clientType !== "wrap") {
        // 如果不是内嵌的网页
        return;
      }
      if (this.$route.path === "/chatRoom") {
        Dialog.confirm({
          title: this.$tex("温馨提示"),
          message: this.$tex("请重新登入")
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            localStorage.setItem("user", "");
            this.SET_USER_INFO({});
          });
      }
    }
  }
};
</script>

<style lang="less">
@rem: 40rem;
.notice-dlg.ui-dialog {
  top: 20% !important;
  box-shadow: 0 0 20px 2px rgba(236, 0, 34, 0.5);
  padding: 0;
  .head {
    border-bottom: 0;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #ffeeee;
    font-size: 30 / @rem;
    display: flex;
    align-items: center;
    padding: 0 25 / @rem;
    color: #ec0022;
    &::before {
      content: "";
      width: 42 / @rem;
      height: 42 / @rem;
      background: url(~@/assets/images/notice.png) no-repeat;
      background-size: 42 / @rem 42 / @rem;
      margin-right: 16 / @rem;
    }
  }
  .d-body {
    padding: 20 / @rem 25 / @rem;
    color: #282828;
    font-size: 27 / @rem;
    min-height: 120 / @rem;
    max-height: 200 / @rem;
    word-break: break-all;
    overflow: hidden;
  }
  .icon-close {
    position: absolute;
    color: #ec0022;
    right: 25 / @rem;
    top: 2 / @rem;
    font-size: 50 / @rem;
  }
}
</style>
